import { useQuery } from '@tanstack/react-query';
import { Heading1 } from '../../../components/headings';
import { getUserSessions } from './api/getUserSessions';
import InlineLoadingSpinner from '../../../components/ui/InlineLoadingSpinner';
import { SessionCard } from './components/SessionCard';

export function SessionsPage() {
    const { data: sessions, status } = useQuery({
        queryKey: ['sessions'],
        queryFn: getUserSessions,
    });

    return (
        <section>
            <Heading1>Sessions</Heading1>
            <InlineLoadingSpinner isLoading={status === 'pending'} />
            {status === 'success' && (
                <ul className='grid lg:grid-cols-2 gap-4'>
                    {sessions?.map((session) => (
                        <SessionCard key={session.id} session={session} />
                    ))}
                </ul>
            )}
        </section>
    );
}
